import { useState, useEffect } from "react";
import { _get_categories } from "../common/axios_services";

const useCategories = (businessId) => {
  const [categories, setCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(false);

  useEffect(() => {
    if (businessId) {
      const getCategories = async () => {
        try {
          setLoadingCategories(true);
          const categoriesResponse = await _get_categories(businessId);
          setCategories(categoriesResponse.data.data);
        } catch (err) {
          console.error("Failed to fetch categories:", err);
        } finally {
          setLoadingCategories(false);
        }
      };
      getCategories();
    }
  }, [businessId]);

  return { categories, loadingCategories };
};

export default useCategories;
